import { useCallback } from 'react';
import { bridge, getRangeForEvent } from 'shared/src/utils';
import type { GoodsReview } from 'shared/src/api/goodsService/getGoodsReviews';
import { EvaluationText } from 'shared/src/constant/domain/review/EvaluationText';

export const useLogClickReview = () => {
  return useCallback((review: GoodsReview) => {
    bridge.logAnalyticsEvent({
      name: 'CLICK_REVIEW',
      analytics: {
        SCREEN: 'GOODS_DETAIL',
        REVIEW_SNO: review.sno,
        EVALUATION: EvaluationText[review.eval],
        IS_IMAGE: review.images_webp.length > 0 ? 1 : 0,
        GOODS_SNO: review.goods_sno,
        LIKE_COUNT: review.review_likes_count,
        LIKES_COUNT_RANGE: getRangeForEvent({
          rangeUnit: 500,
          target: review.review_likes_count ?? 0,
        }),
        REVIEW_DELIVERY_TYPE: review.delivery_type,
      },
    });
  }, []);
};
